import {
  setScheduleTourPhone,
  selectScheduleTourPhone,
  setScheduleTourStepAdvanceOneStep,
  selectScheduleTourStep,
  setScheduleTourShowModal,
  setScheduleTourStep,
  STEPS,
  STEPS_CONST,
  STEPS_REA,
  setScheduleTourStepAdvanceTwoSteps
} from '../../../../../../../../store/slices/scheduleTour'
import { ChangeEvent, useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import PhoneInput from '../../../../../../../shared/Input/PhoneInput'
import { isValidPhoneNumber, removeCountryCode } from '../../../../../../../../helpers/formatters'
import { TEL } from '../../../../../../../shared/FormField/types'
import Step from '../../../../../ModalStepsOutline'
import { selectClientMobile } from '../../../../../../../../store/selectors/client'
import styles from './Contact.module.scss'
import { RootState } from '../../../../../../../../types/rootState'
import { selectCustomerIsRealEstateAgent } from '../../../../../../../../store/selectors/customerProfile'

export const Contact = () => {
  const dispatch = useDispatch()
  const inputRef = useRef<HTMLInputElement>(null)
  const tourPhone = useSelector(selectScheduleTourPhone)
  const currentStep = useSelector(selectScheduleTourStep)
  const stepIndex = STEPS.indexOf(currentStep)
  const clientPhone = useSelector<RootState, string>(selectClientMobile) || ''
  const isCustomerREA = useSelector(selectCustomerIsRealEstateAgent)

  useEffect(() => {
    inputRef?.current?.focus()
  }, [])

  // default the phone number to the one we have saved in the client's profile
  useEffect(() => {
    if (clientPhone && !tourPhone) {
      dispatch(setScheduleTourPhone(clientPhone))
    }
  }, [clientPhone, dispatch, tourPhone])

  const handleButtonClick = () => {
    if (isCustomerREA) {
      dispatch(setScheduleTourStepAdvanceTwoSteps())
    } else {
      dispatch(setScheduleTourStepAdvanceOneStep())
    }
  }
  const onPhoneNumChange = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(setScheduleTourPhone(e.target.value))
  }

  return (
    <Step stepLabel='schedule-tour-contact'>
      <Step.HeaderNavSection
        currentStep={currentStep}
        steps={isCustomerREA ? STEPS_REA : STEPS}
        onCancel={() => dispatch(setScheduleTourShowModal(false))}
        onBack={() => dispatch(setScheduleTourStep(STEPS_CONST[stepIndex - 1]))}
      />
      <Step.Title labelFor='contact-step-input'>
        <FormattedMessage
          id='ScheduleTour.Contact.Label'
          defaultMessage='What is the best phone number to reach you?'
        />
      </Step.Title>
      <Step.Body>
        <PhoneInput
          className={styles.phoneInput}
          type={TEL}
          allowEmptyFormatting
          ref={inputRef}
          id='contact-step-input'
          value={tourPhone}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onPhoneNumChange(e)}
        />
      </Step.Body>
      <Step.FooterButton
        disableButton={!isValidPhoneNumber(removeCountryCode(tourPhone))}
        onClick={() => dispatch(handleButtonClick)}
      >
        <FormattedMessage id='ScheduleTour.FooterButton.NextStep' defaultMessage='Next Step' />
      </Step.FooterButton>
    </Step>
  )
}
